import axios, { InternalAxiosRequestConfig } from 'axios';

import config from 'config';

import { getAccessToken } from './auth';
import { getRequestId } from './create-request-id';

const {
  bff: { applicationID, baseUrl, clientID },
} = config;

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    Application: applicationID,
    client_id: clientID,
    'Content-Type': 'application/json',
    'session-id': getRequestId(),
  },
});

const embbedAuthToken = (request: InternalAxiosRequestConfig) => {
  const authToken = getAccessToken();
  if (!authToken) {
    const error = new Error('Token não encontrado');
    throw error;
  }

  request.headers.Authorization = `Bearer ${authToken}`;
  return request;
};

api.interceptors.request.use(embbedAuthToken);

api.interceptors.response.use(
  (response) => Promise.resolve(response.data),
  (error) => Promise.reject(error?.response || error)
);

export default api;
